import PrimaryButton from "./PrimaryButton";

export default PrimaryButton;



// WEBPACK FOOTER //
// ./src/shared/components/PrimaryButton/index.js